type IndexesOfMatches = {
    endPos: number,
    startPos: number,
    type?: string,
};

type GetIndexesOfMatches = (mainText: string, highlightText: string) => Array<IndexesOfMatches>;

export const getIndexesOfMatches: GetIndexesOfMatches = (mainText, highlightText) => {
    const rule = new RegExp(highlightText.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi');
    const ruleLength = highlightText.length;
    const indexes: Array<IndexesOfMatches> = [];

    if (highlightText.length > 0) {
        mainText.replace(rule, (x, index) => {
            indexes.push({
                startPos: index,
                endPos: index + ruleLength,
            });
            return x;
        });
    }
    return indexes;
};

type RemoveDuplicates = (matches: Array<IndexesOfMatches>) => Array<IndexesOfMatches>;

export const removeDuplicates: RemoveDuplicates = matches => {
    return matches.reduce((acc: Array<IndexesOfMatches>, current: IndexesOfMatches) => {
        const isDuplicate = acc.some(item => item.startPos === current.startPos && item.endPos === current.endPos);
        if (!isDuplicate) {
            acc.push(current);
        }
        return acc;
    }, []);
};

type MergeIntersections = (matches: Array<IndexesOfMatches>) => Array<IndexesOfMatches>;

export const mergeIntersections: MergeIntersections = matches => {
    return matches.reduce((acc: Array<IndexesOfMatches>, match: IndexesOfMatches) => {
        const index = acc.findIndex(item => (
            item.startPos <= match.startPos && item.endPos >= match.startPos ||
            match.startPos <= item.startPos && match.endPos >= item.startPos
        ));
        if (index >= 0) {
            const current = acc[index];
            acc[index] = {
                ...current,
                startPos: current.startPos < match.startPos ? current.startPos : match.startPos,
                endPos: current.endPos < match.endPos ? match.endPos : current.endPos,
            };
        } else {
            acc.push(match);
        }
        return acc;
    }, []);
};

export const prepareMatches = (matches: Array<IndexesOfMatches>) => mergeIntersections(removeDuplicates(matches));

type GetHighlightedMatches = (text: string, matches?: Array<IndexesOfMatches>) => string;

export const getHighlightedMatches: GetHighlightedMatches = (text, matches) => {
    if (text.length > 0 && matches && Array.isArray(matches) && matches.length > 0) {
        return prepareMatches(matches)
            .filter(item => item.startPos < text.length)
            .slice(0)
            .reverse()
            .reduce((str, {startPos, endPos}) =>
                `${str.slice(0, startPos)}<mark>${str.slice(startPos, endPos)}</mark>${str.slice(endPos)}`, text);
    }
    return text;
};
